import storage from "store";
import { login } from "@/api/system/login";
import { USER_TOKEN, REFRESH_TOKEN, USER } from "@/store/mutation-types";

const user = {
  state: {
    user: {}
  },

  mutations: {
    SET_USER: (state, user) => {
      state.user = user;
    }
  },

  actions: {
    // 登录
    Login(e, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(res => {
            const result = res.result;

            // 如果没有token，则说明登录失败，走失败处理 BY CHU @20210219 修正登录消息提示问题
            if (!result.user_token) {
              reject(res);
            } else {
              // user_token
              storage.set(USER_TOKEN, result.user_token, 60 * 60 * 1000);
              // refresh_token
              storage.set(
                REFRESH_TOKEN,
                result.refresh_token,
                24 * 60 * 60 * 1000
              );
              storage.set(USER, result, 24 * 60 * 60 * 1000);
              resolve(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    Logout({ commit }) {
      return new Promise(resolve => {
        commit("SET_USER", {});
        commit("SET_ROUTERS", []);
        storage.remove(USER_TOKEN);
        storage.remove(REFRESH_TOKEN);
        storage.remove(USER);
        resolve();
      });
    }
  }
};

export default user;
